import { Skeleton } from "@mui/material";
import { MprcRibbonListCardsWrapContainer } from "components/MprcRibbonList";
import React from 'react';
import { GeneralCardLoading } from 'views/general/Cards';

export const MprcRibbonTabLoading = () => {
    return (
        <MprcRibbonListCardsWrapContainer>
            <div>
                <Skeleton width={150} height={40} />
                <GeneralCardLoading />
            </div>
        </MprcRibbonListCardsWrapContainer>
    );
};
